module.exports = __webpack_public_path__ + "img/file-contract-solid.42e6a24d.svg";